// extracted by mini-css-extract-plugin
module.exports = {"root":"DocHeader-module--root--u2Yw4","logo":"DocHeader-module--logo--1m7eo","brand":"DocHeader-module--brand--Vlp5T"};